__turbopack_context__.v({
  "desktopPrimaryOffers": "MUURVq_desktopPrimaryOffers",
  "mobilePrimaryOffers": "MUURVq_mobilePrimaryOffers",
  "primaryOffersWrapper": "MUURVq_primaryOffersWrapper",
});
